/* Signing out, for every place that offers it. A session that had already ended is signed out too (model/session.ts signOutOutcome). */
import { navigate } from '../lib/router.tsx'
import { refusalOf, v1 } from './api.ts'
import { signOutOutcome } from './model/session.ts'

export async function signOut(say: (text: string, tone?: 'info' | 'fail') => void): Promise<void> {
  let refused: Error | null = null
  try {
    await v1.signOut()
  } catch (e) {
    refused = e as Error
  }
  const out = signOutOutcome(refused ? refusalOf(refused) : null)
  if (out.to) navigate(out.to, { replace: true })
  if (out.line) say(out.line, 'fail')
}
